import React from "react";
import DataTable from "../../datatable/DataTable";
import { formatTime } from "../../../../utils/tools";

const buildWalkthroughColumns = (onViewDetails) => [
  {
    accessorKey: "favicon",
    header: () => (
      <div className="text-table-avatar-model"> </div>
    ),
    cell: ({ row }) => {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
          <img
            src={row.getValue("favicon")}
            style={{ width: "35px", height: "35px", borderRadius: "100px" }}
          />
        </div>
      );
    },
  },
  {
    accessorKey: "material_name",
    header: () => (
      <div className="text-table-avatar-model">Material name</div>
    ),
    cell: ({ row }) => {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
          <div className="text-table-avatar-model">
            {row.getValue("material_name")}
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: "status",
    header: () => (
      <div className="text-table-avatar-model">Status</div>
    ),
    cell: ({ row }) => {
      return (
        <div
          className={`activity-status ${row.getValue("status")}`}
          style={{ width: "fit-content", textTransform: "capitalize" }}
        >
          {row.getValue("status")}
        </div>
      );
    },
  },
  {
    accessorKey: "time_spent_minutes",
    header: () => (
      <div className="text-table-avatar-model">Time Spent</div>
    ),
    cell: ({ row }) => {
      const totalMinutes = parseInt(row.getValue("time_spent_minutes") ?? row.original?.data?.minutes ?? 0, 10);
      const timeString = formatTime(totalMinutes);

      return (
        <div className="text-table-avatar-model">
          {timeString}
        </div>
      );
    },
  },
  {
    accessorKey: "progress",
    header: () => (
      <div className="text-table-avatar-model">Progress</div>
    ),
    cell: ({ row }) => {
      const progressValue = Math.max(0, Math.min(100, parseInt(row.getValue("progress"), 10) || 0));
      return (
        <div className="rating-data-table">
          <div className="counter-progress-bar">{progressValue}%</div>
          <div className="rating-progress-bar">
            <div className="current-progress-bar" style={{ width: `${progressValue}%` }} />
          </div>
        </div>
      );
    },
  },
  {
    id: "view",
    header: () => (
      <div className="text-table-avatar-model">Details</div>
    ),
    cell: ({ row }) => {
      const material = {
        learning_material_id: row.original?.learning_material_id,
        material_name: row.original?.material_name,
        material_type: row.original?.material_type
      };
      return (
        <div className="button-flex text-center">
          <button
            type="button"
            className="btn-avatar-details"
            onClick={() => onViewDetails?.(material)}
          >
            <span className="text-btn-avatar-details">View</span>
          </button>
        </div>
      );
    },
  },
];

function Walkthroughs({ data = {}, onViewDetails }) {
  const totalMinutes = parseInt(data?.total_study_time || 0, 10);
  const timeString = formatTime(totalMinutes);
  const rows = Array.isArray(data?.data) ? data.data : [];
  const columns = buildWalkthroughColumns(onViewDetails);

  return (
    <div className="activity-table-wrapper">
      <div className="title">
        <h5>Walkthroughs</h5>
        <p>Total spend time: {timeString}</p>
      </div>
      <DataTable
        columns={columns}
        data={rows}
        isPaginationEnabled={false}
      />
    </div>
  );
}

export default Walkthroughs;
